import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PayoutStatementsDialogContentComponent } from './payout-statements-dialog-content/payout-statements-dialog-content.component';

@Component({
  selector: 'payout-statements-dialog',
  template: ''
})
export class PayoutStatementsDialogComponent implements OnDestroy {
  
  private modal: NgbModalRef | null = null

  constructor(
    public modalService: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngAfterViewInit() {
    if (this.modalService.hasOpenModals()) return
    this.openDialog();
  }

  openDialog(): void {
    if (this.modal) {
      this.modal.close()
    }

    this.modal = this.modalService.open(
      PayoutStatementsDialogContentComponent,
      { centered: true, backdrop: 'static', size: 'lg' }
    )

    this.modal.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute })
    }, (reason) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute })
    })
  }

  ngOnDestroy() {
    if (this.modal) {
      this.modal.close()
    }
  }
}
